// extracted by mini-css-extract-plugin
export default {"-large":"SvYdypWD6xIblxLjRV45","nav":"yt3qwpJimaW40Msv0PHL","navIn":"hU6DIAIcoWKK4xKpcMfP","logo":"YSgWpdoQQd9cZS5Z9PdV"};